export enum DepositSecurityType {
	WithoutSecurity = 1,
	TimeDeposit = 2,
	TimeDepositWithSecureCode = 3,

}